export default "__VITE_ASSET__DXUkPN0r__"